"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMobLayoutStyles = exports.getGridStyles = exports.getTheme = void 0;

var _styledComponents = require("styled-components");

var _uiKit = require("@dbi-tools/ui-kit");

var _themeOptions = require("../../helpers/theme-options");

var _iconGrid = require("./icon-grid.styled");

var _types = require("./types");

var getItemStyles = function getItemStyles(theme) {
  switch (theme) {
    case _themeOptions.ThemeNoCardVariants.SEASHELL_NO_CARD:
    case _themeOptions.ThemeNoCardVariants.MOCASSIN_NO_CARD:
    case _themeOptions.ThemeNoCardVariants.CLARET_NO_CARD:
    case _themeOptions.ThemeNoCardVariants.BLACK_NO_CARD:
      return (0, _styledComponents.css)(["", "{background-color:transparent;}"], _iconGrid.GridItem);

    default:
      return "";
  }
};

var getTheme = function getTheme(theme) {
  var GridItemStyles = getItemStyles(theme);

  switch (theme) {
    case _themeOptions.ThemeNoCardVariants.SEASHELL:
    case _themeOptions.ThemeNoCardVariants.SEASHELL_NO_CARD:
      return (0, _styledComponents.css)(["background-color:", ";", ";"], _uiKit.Colors.secondaryLight, GridItemStyles);

    case _themeOptions.ThemeNoCardVariants.MOCASSIN:
    case _themeOptions.ThemeNoCardVariants.MOCASSIN_NO_CARD:
      return (0, _styledComponents.css)(["background-color:", ";", ";"], _uiKit.Colors.secondary, GridItemStyles);

    case _themeOptions.ThemeNoCardVariants.CLARET:
    case _themeOptions.ThemeNoCardVariants.CLARET_NO_CARD:
      return (0, _styledComponents.css)(["background-color:", ";color:", ";", ";"], _uiKit.Colors.wine, _uiKit.Colors.white, GridItemStyles);

    case _themeOptions.ThemeNoCardVariants.BLACK:
    case _themeOptions.ThemeNoCardVariants.BLACK_NO_CARD:
      return (0, _styledComponents.css)(["background-color:", ";color:", ";", ";"], _uiKit.Colors.gray800, _uiKit.Colors.white, GridItemStyles);

    default:
      return (0, _styledComponents.css)(["background-color:", ";"], _uiKit.Colors.white);
  }
};

exports.getTheme = getTheme;

var getGridStyles = function getGridStyles() {
  var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;

  switch (columns) {
    case 3:
      return (0, _styledComponents.css)(["", "{min-width:calc(33.3% - ", "px);max-width:calc(33.3% - ", "px);}"], _iconGrid.GridItem, offset, offset);

    case 4:
      return (0, _styledComponents.css)(["", "{min-width:calc(25% - ", "px);max-width:calc(25% - ", "px);}"], _iconGrid.GridItem, offset, offset);

    default:
      return (0, _styledComponents.css)(["", "{min-width:calc(50% - ", "px);max-width:calc(50% - ", "px);}"], _iconGrid.GridItem, offset, offset);
  }
};

exports.getGridStyles = getGridStyles;

var getMobLayoutStyles = function getMobLayoutStyles(mobileLayout) {
  switch (mobileLayout) {
    case _types.KeyValueLayoutType.scroll:
      return (0, _styledComponents.css)(["display:block;padding:0;position:relative;", "{height:100%;margin:0 15px !important;max-width:309px;width:309px;}", "{padding:0 !important;", "{max-width:279px;width:279px;}}", "{padding-right:0 !important;", "{max-width:261px;width:261px;}}"], _iconGrid.GridItem, _uiKit.GridBreakpointsMediaDown.lg, _iconGrid.GridItem, _uiKit.GridBreakpointsMediaDown.md, _iconGrid.GridItem);

    case _types.KeyValueLayoutType.carousel:
      return (0, _styledComponents.css)(["display:block;padding:0;.slick-list{margin:0 35px;}", "{height:100%;max-width:309px;padding-left:70px;padding-right:70px;}", "{max-width:calc(100% - 48px);.slick-list{margin:0;}", "{max-width:100%;padding-left:15px;padding-right:15px;}}"], _iconGrid.GridItem, _uiKit.GridBreakpointsMediaDown.md, _iconGrid.GridItem);

    case _types.KeyValueLayoutType.stack:
      return (0, _styledComponents.css)(["align-items:center;flex-direction:column;max-width:calc(100% - 214px);", "{flex:0 0 auto;min-width:auto;max-width:524px;width:calc(100% - 30px);}", "{", "{margin:15px 0;width:100%;flex-direction:column !important;}}", "{max-width:100%;margin:0;", "{flex-direction:column !important;}}", "{img{height:auto !important;width:70px;}}"], _iconGrid.GridItem, _uiKit.GridBreakpointsMediaDown.md, _iconGrid.GridItem, _uiKit.GridBreakpointsMediaDown.sm, _iconGrid.GridItem, _uiKit.GridBreakpointsMediaUp.md);

    default:
      return (0, _styledComponents.css)(["", "{align-items:center;flex-direction:column;", "{flex:auto;min-width:auto;max-width:100%;width:100%;margin:15px 0;}}"], _uiKit.GridBreakpointsMediaDown.md, _iconGrid.GridItem);
  }
};

exports.getMobLayoutStyles = getMobLayoutStyles;